import { shouldShowTimedBanner } from '../utils';
import { useBackfillShallowStore } from './use-backfill-store';
import { useCallIntelTrial } from './use-call-intel-trial';
import { usePermanentDismissOnVisit } from './use-permanent-dismiss-on-visit';

/**
 * Determines whether the trial backfill batch-1-ready global banner should be visible.
 *
 * Conditions (all must be true):
 * - At least one location has an active CI trial
 * - User has CALL_INTELLIGENCE_READ permission on trial locations
 * - First batch is ready but full backfill is not yet complete
 * - Banner has not been dismissed (or 7 days have passed without visiting CI)
 */
export const useBackfillBatch1BannerVisibility = () => {
  const { hasTrialAccess, isOnCallIntelligenceRoute, hasTrialLocations, isFirstBatchReady, isFullyComplete } =
    useCallIntelTrial();
  const { batch1ReadyBannerDismiss, dismissBatch1ReadyBanner } = useBackfillShallowStore(
    'batch1ReadyBannerDismiss',
    'dismissBatch1ReadyBanner'
  );

  usePermanentDismissOnVisit({
    dismissState: batch1ReadyBannerDismiss,
    isOnCallIntelligenceRoute,
    onDismiss: dismissBatch1ReadyBanner,
    shouldDismiss: isFirstBatchReady && !isFullyComplete,
  });

  const isVisible =
    hasTrialLocations &&
    hasTrialAccess &&
    isFirstBatchReady &&
    !isFullyComplete &&
    shouldShowTimedBanner(batch1ReadyBannerDismiss);

  return {
    dismiss: dismissBatch1ReadyBanner,
    isOnCallIntelligenceRoute,
    isVisible,
  };
};
